import { PropsWithChildren } from "react";
import styled from "styled-components";
import { DialogProps, Overlay as OverlayBase } from "@radix-ui/react-dialog";
import { zIndex } from "../../styles/constants";
import { opacity00 } from "../../styles/tokens";

// TEXT

// STYLES
export const Overlay = styled(OverlayBase)`
  inset: 0;
  z-index: ${zIndex.overlay};
  position: fixed;

  background-color: ${opacity00};
`;

// DATA

// TYPES
export interface Props
  extends PropsWithChildren,
    Pick<DialogProps, "open" | "onOpenChange" | "modal"> {}

// CONSTANTS

// FUNCTIONS

// ASSETS
